import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[appDurationValue]',
    standalone: false
})
export class DurationValueDirective {
  @Input() durationList: any[] = [];
  private regex: RegExp = new RegExp(/^-?[1-9][0-9]{0,}$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', '-', 'ArrowLeft', 'ArrowRight', 'ArrowDown', 'ArrowUp', 'Delete',
  'Enter'];
  constructor(private el: ElementRef, private control: NgControl) {
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.regex = new RegExp(/^-?[1-9][0-9]{0,}$/g)

    if (this.specialKeys.indexOf(event.key) !== -1 || event.ctrlKey) {
      return;
    }
    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }else if(next >= this.durationList[0]?.value && !this.durationList.filter(x => x.value == next).length){
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event) {
    const current = event.clipboardData && event.clipboardData.getData('text') ?
      this.regex.test(String(event.clipboardData.getData('text'))) : null;
    if (!current || (current >= this.durationList[0]?.value && !this.durationList.filter(x => x.value == current).length)) {
      event.preventDefault();
    }
  }

  @HostListener('blur', ['$event'])
  onBlur(event) {
    setTimeout(() => {
      const current = this.el.nativeElement.value;
      const abstractControl = this.control.control;

      if (abstractControl && !current) {
        abstractControl.setValue(this.durationList[0]?.value);
        abstractControl.updateValueAndValidity();
      }
    }, 100);
  }
}
